export const DrawerTitle = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element => {
  return <div className="font-semibold leading-none text-md">{children}</div>;
};
